export const ADMIN_DEFAULT_LANDING = '/admin/user-status';

export type AdminNavItem = {
  label: string;
  path: string;
  /** Platform-owner screens: brands, aliases, Stripe secrets, platform referral rates. */
  platformOwnerOnly?: boolean;
  /** Shown only on the services site (spec 019). */
  servicesSiteOnly?: boolean;
};

export const ADMIN_NAV_ITEMS: readonly AdminNavItem[] = [
  { label: 'Host Applications', path: '/admin/user-status' },
  { label: 'Brand Settings', path: '/admin/brand-settings' },
  { label: 'Page settings', path: '/admin/page-settings' },
  { label: 'Policies', path: '/admin/policies' },
  { label: 'Airports', path: '/admin/delivery-locations' },
  { label: 'Unlisted cars', path: '/admin/unlisted-cars' },
  { label: 'Card name checks', path: '/admin/card-name-checks' },
  { label: 'Hot Locations', path: '/admin/hot-locations' },
  { label: 'Referral Commissions', path: '/admin/referral-commissions' },
  { label: 'Damage Claims', path: '/admin/damage-claims' },
  { label: 'Broadcasts', path: '/admin/broadcasts' },
  { label: 'Service Providers', path: '/admin/service-providers', servicesSiteOnly: true },
  { label: 'Service jobs', path: '/admin/service-jobs', servicesSiteOnly: true },
  { label: 'Worker strikes', path: '/admin/service-workers', servicesSiteOnly: true },
  { label: 'Service payouts', path: '/admin/service-payouts', servicesSiteOnly: true },
  {
    label: 'Service tax',
    path: '/admin/service-tax',
    servicesSiteOnly: true,
    platformOwnerOnly: true,
  },
  {
    label: 'Minimum wages',
    path: '/admin/minimum-wages',
    servicesSiteOnly: true,
    platformOwnerOnly: true,
  },
  { label: 'Platform websites', path: '/admin/platform-sites', platformOwnerOnly: true },
  {
    label: 'Verify General DL',
    path: '/admin/verify-general-drivers-license',
    platformOwnerOnly: true,
  },
  { label: 'Brands', path: '/admin/brands', platformOwnerOnly: true },
  { label: 'App features', path: '/admin/app-features', platformOwnerOnly: true },
] as const;
